import React from 'react';

import { Colors } from 'enums/Colors';
import { FlowBackground } from 'components/FlowBackground';
import { Header } from 'components/Header';
import { FlowContainer } from 'components/FlowContainer';

import styles from './FlowLayout.module.scss';

interface Props {
  backgroundColor?: Colors;
  symbolColor?: Colors;
  size?: 'default' | 'large';
}

export const FlowLayout: React.FC<Props> = ({
  size = 'default',
  backgroundColor = Colors.DarkBlue,
  symbolColor = Colors.DarkBlue700,
  children,
}) => (
  <div className={styles.wrapper}>
    <FlowBackground backgroundColor={backgroundColor} symbolColor={symbolColor}>
      <Header isInverted />
      <FlowContainer size={size}>{children}</FlowContainer>
    </FlowBackground>
  </div>
);
